import { LOADING, LOADING_SERVICE_TOKEN } from '@aksia/infrastructure';
import {
  Directive,
  HostBinding,
  inject,
  input,
  model,
  Signal,
} from '@angular/core';

@Directive({
  selector: '[uiloading],[uiloading-absolute],[uiloading-fixed]',
  standalone: true,
})
export class UiLoadingDirective {
  protected readonly loadingService = inject(LOADING_SERVICE_TOKEN);

  uiloading = input<string | undefined, string | undefined>(undefined, {
    transform: (value) => value && this.initLoading(value),
  });
  #uiLoading!: Signal<string | undefined>;

  silenced = model<boolean>(false);

  initLoading(value: string | undefined) {
    if (value === LOADING.PAGE) {
      this.#uiLoading = this.loadingService?.pageLoading!;
    } else {
      this.#uiLoading = this.loadingService?.areaLoading!(value!);
    }
    return value;
  }

  @HostBinding('attr.uiloading') get uiLoadingValue() {
    return this.silenced() ? undefined : this.#uiLoading?.();
  }
}
